import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function StaffRoute() {
  const { user } = useAuth()

  if (!user) return null

  if (user.role === 'user') return <Navigate to="/profile" replace />
  if (user.role === 'client') return <Navigate to="/dashboard" replace />

  // super_admin, org_admin, staff all pass through
  return <Outlet />
}
